export default __webpack_public_path__ + "static/media/brownSlab.38f05dc4.svg";